import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../structure/row';
import { Cell, CENTER } from '../structure/cell';
import Translation from '../../translation/translation';

export function OptionSeparator() {
    return (
        <Row className="options-separator-row">
            <Cell side={CENTER} colSpan={2} className="options-separator">
                <Translation
                    className="options-separator__text"
                    translationKey="pdp-sidebar-option-separator-label"
                />
            </Cell>
        </Row>
    );
}
